import React, { useState, useEffect } from 'react';
import Layout from '../../components/layout/Layout';
import auditoriaService from '../../services/auditoriaService';
import usuarioService from '../../services/usuarioService';
import { formatearFecha } from '../../utils/helpers';
import { FaHistory, FaSearch } from 'react-icons/fa';

const ACCIONES = ['crear', 'editar', 'eliminar', 'consultar', 'exportar', 'login', 'logout'];

export default function AuditoriaPage() {
  const [logs,      setLogs]      = useState([]);
  const [usuarios,  setUsuarios]  = useState([]);
  const [cargando,  setCargando]  = useState(true);
  const [filtros,   setFiltros]   = useState({
    usuario_id:  '',
    accion:      '',
   fecha_inicio: ``,
   fecha_fin:    ``,
  });

  useEffect(() => {
    cargarUsuarios();
    cargarLogs();
  }, []);

  const cargarUsuarios = async () => {
    const data = await usuarioService.listar();
    setUsuarios(data);
  };

  const cargarLogs = async (filtrosActuales = filtros) => {
    setCargando(true);
    try {
      const data = await auditoriaService.listar(filtrosActuales);
      setLogs(data.data || []);
    } finally {
      setCargando(false);
    }
  };

  const handleFiltro = (e) => {
    const { name, value } = e.target;
    setFiltros((prev) => ({ ...prev, [name]: value }));
  };

  const handleBuscar = (e) => {
    e.preventDefault();
    cargarLogs(filtros);
  };

  const getBadgeAccion = (accion) => {
    const colores = {
      crear:    'bg-success',
      editar:   'bg-primary',
      eliminar: 'bg-danger',
      exportar: 'bg-warning text-dark',
      login:    'bg-info',
      logout:   'bg-secondary',
      consultar:'bg-light text-dark',
    };
    return colores[accion] || 'bg-secondary';
  };

  return (
    <Layout>

      {/* Encabezado */}
      <div className="page-header">
        <h4>Auditoría del Sistema</h4>
        <p>Seguimiento de actividades de usuarios</p>
      </div>

      {/* Filtros */}
      <div className="card card-custom mb-3">
        <div className="card-body">
          <form onSubmit={handleBuscar}>
            <div className="row g-2 align-items-end">

              <div className="col-md-3">
                <label className="form-label small fw-bold">Usuario</label>
                <select
                  name="usuario_id"
                  className="form-select form-select-sm"
                  value={filtros.usuario_id}
                  onChange={handleFiltro}
                >
                  <option value="">Todos los usuarios</option>
                  {usuarios.map((u) => (
                    <option key={u.id} value={u.id}>
                      {u.nombre} {u.apellido}
                    </option>
                  ))}
                </select>
              </div>

              <div className="col-md-2">
                <label className="form-label small fw-bold">Acción</label>
                <select
                  name="accion"
                  className="form-select form-select-sm"
                  value={filtros.accion}
                  onChange={handleFiltro}
                >
                  <option value="">Todas</option>
                  {ACCIONES.map((a) => (
                    <option key={a} value={a}>{a}</option>
                  ))}
                </select>
              </div>

              <div className="col-md-2">
                <label className="form-label small fw-bold">Desde</label>
                <input
                  name="fecha_inicio"
                  type="date"
                  className="form-control form-control-sm"
                  value={filtros.fecha_inicio}
                  onChange={handleFiltro}
                />
              </div>

              <div className="col-md-2">
                <label className="form-label small fw-bold">Hasta</label>
                <input
                  name="fecha_fin"
                  type="date"
                  className="form-control form-control-sm"
                  value={filtros.fecha_fin}
                  onChange={handleFiltro}
                />
              </div>

              <div className="col-md-2">
                <button type="submit" className="btn btn-danger btn-sm w-100">
                  <FaSearch className="me-1" /> Buscar
                </button>
              </div>

            </div>
          </form>
        </div>
      </div>

      {/* Tabla */}
      <div className="card card-custom">
        <div className="card-body">
          {cargando ? (
            <div className="text-center py-4">
              <div className="spinner-custom mx-auto" />
            </div>
          ) : (
            <div className="table-responsive">
              <table className="table table-custom table-sm">
                <thead>
                  <tr>
                    <th>Fecha</th>
                    <th>Usuario</th>
                    <th>Acción</th>
                    <th>Tabla</th>
                    <th>Descripción</th>
                  </tr>
                </thead>
                <tbody>
                  {logs.length > 0 ? (
                    logs.map((log) => (
                      <tr key={log.id}>
                        <td className="small text-muted">
                          {new Date(log.created_at).toLocaleString('es-PE')}
                        </td>
                        <td className="fw-bold">
                          {log.usuario
                            ? `${log.usuario.nombre} ${log.usuario.apellido}`
                            : 'Sistema'}
                        </td>
                        <td>
                          <span className={`badge ${getBadgeAccion(log.accion)}`}>
                            {log.accion}
                          </span>
                        </td>
                        <td>
                          <span className="badge bg-light text-dark">
                            {log.tabla_afectada}
                          </span>
                        </td>
                        <td className="small text-muted">
                          {log.descripcion || '—'}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="5" className="text-center text-muted py-4">
                        <FaHistory size={32} className="mb-2 d-block mx-auto" />
                        Sin registros de auditoría
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>

    </Layout>
  );
}